import { SagaIterator } from 'redux-saga';
import { call, put } from 'redux-saga/effects';

import { ChangeContentOwnerAction } from '~content/services/ChangeContentOwnerAction';

import { requestFailed } from '../../app/actions/RequestFailedAction';
import { requestSpaceContents } from '../../app/actions/spaces/RequestSpaceContentsActions';
import { SetOwnerAction } from '../../app/actions/spaces/SetOwnerAction';
import { reloadSpaceIfUpdatingCurrentSpace } from '../../app/sagas/spaces/content/RefreshContentSagas';
import { replaceDatasourceIdWithConnectionIdForMixedContent } from '../../app/sagas/spaces/SpacesSagaHelpers';
import { Messages } from '../../codegen/Localize';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { IContentInfo } from '../../ts/models/IContentInfo';
import { IUserInfo } from '../../ts/models/IUserInfo';
import { Users } from '../../userManagement/services/resources/Users';

export function* handleSetOwner(action: SetOwnerAction): SagaIterator {

  try {
    let mutatableContentCopy: IContentInfo[] = [];
    mutatableContentCopy = yield call(replaceDatasourceIdWithConnectionIdForMixedContent, action.items);

    try {
      yield call(openSetContentOwnerDialog, mutatableContentCopy);
    } catch {
      return;
    }

    const maybeReloaded = yield call(reloadSpaceIfUpdatingCurrentSpace, action.items);
    if (!maybeReloaded) {
      yield put(requestSpaceContents());
    }
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

export function openSetContentOwnerDialog(items: IContentInfo[]): Promise<IResult> {
  return ChangeContentOwnerAction.confirmChangeOwner(items);
}

export function getUser(userId: string): Promise<IUserInfo> {
  return Users.instance.getById(userId);
}
